import React from "react";

export default function Dot({ selected, onClick, index }) {
  let classNames = "";
  if (selected) {
    classNames = "opacity-100 bg-primary";
  } else {
    classNames = "hover:opacity-70 bg-gray-300";
  }

  return (
    <div
      className={`w-[10px] h-[10px] rounded-full opacity-100 transition-all duration-300 ease-linear hover:cursor-pointer ${classNames}`}
      onClick={() => {
        onClick(index);
      }}
    ></div>
  );
}
